/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetTypeRequestDto
 */
export interface CreateAssetTypeRequestDto {
    /**
     * Unique code for the asset type
     * @type {string}
     * @memberof CreateAssetTypeRequestDto
     */
    code: string;
    /**
     * Name of the asset type
     * @type {string}
     * @memberof CreateAssetTypeRequestDto
     */
    name: string;
    /**
     * Description of the asset type
     * @type {string}
     * @memberof CreateAssetTypeRequestDto
     */
    description?: string;
    /**
     * JSON schema for metadata validation
     * @type {{ [key: string]: any; }}
     * @memberof CreateAssetTypeRequestDto
     */
    metadataSchema?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreateAssetTypeRequestDto interface.
 */
export function instanceOfCreateAssetTypeRequestDto(value: object): value is CreateAssetTypeRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateAssetTypeRequestDtoFromJSON(json: any): CreateAssetTypeRequestDto {
    return CreateAssetTypeRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
    };
}

export function CreateAssetTypeRequestDtoToJSON(json: any): CreateAssetTypeRequestDto {
    return CreateAssetTypeRequestDtoToJSONTyped(json, false);
}

export function CreateAssetTypeRequestDtoToJSONTyped(value?: CreateAssetTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
    };
}

